<div class="filter">
  <button class="btn btn-primary" (click)="toggleOptionView()" #filterButton>
    <span class="badge badge-danger" *ngIf="selectedItemsList?.length > 0">{{
      selectedItemsList.length
    }}</span>
    <img class="mr-2" [src]="settings.filterImage" />
    <span>{{ settings.filterText }}</span>
  </button>
</div>

<div class="option-view" *ngIf="showOptions" #optionView>
  <div class="search">
    <div class="input d-flex">
      <img class="ml-2 mr-1" src="/assets/icons/search.png" />
      <div class="group">
        <input
          type="text"
          class="control"
          id="search"
          [(ngModel)]="filterName"
          (ngModelChange)="filterValueChanged($event)"
          required
        />
        <label for="search">Search</label>
      </div>
    </div>
  </div>
  <div class="option-list">
    <ng-container *ngFor="let option of settings.options">
      <label
        *ngIf="!option.hide"
        class="container"
        (click)="optionClicked(option)"
      >
        {{ option.value.value }}
        <span class="checkmark" [ngClass]="{ checked: option.selected }">
          <img
            class="check-icon"
            *ngIf="option.selected"
            src="/assets/icons/check.svg"
          />
        </span>
      </label>
    </ng-container>
  </div>
</div>
